/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// pass types
export const ADULT_YOUTH_PASS = 1;
export const INTERAGENCY_PASS = 2;
export const SENIOR_PASS = 3;
export const LOCAL_PASS = 4;
export const ADULT_PASS = 5;
export const YOUTH_PASS = 6;
export const NON_COMMERCIAL_PASS = 7;
export const COMMERCIAL_PASS = 8;
